import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0;
import { __rest as e } from "../_virtual/_tslib.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { ButtonIcon as i } from "@vds-core/button-icons";
import { TextLink as o } from "@vds-core/buttons";
import r from "@vds-core/icons/down-caret";
import { Fonts as a } from "@vds-core/typography";
import { calculateRem as d, hexToRgba as l, getNodeText as c } from "@vds-core/utilities";
import { AccessibilityTokens as s } from "@vds-tokens/accessibility";
import { ColorTokens as p } from "@vds-tokens/color";
import { LayoutTokens as g } from "@vds-tokens/layout";
import { TypographyTokens as u } from "@vds-tokens/typography";
import { createElement as f, Component as v, Children as h, cloneElement as m } from "react";
import b, { css as $ } from "styled-components";
var y = d(g.space["6X"].value),
  k = d(g.space["8X"].value),
  w = function w(e, t, n, i) {
    var o = "mobile" === e;
    return t ? 0 : d("icon" === n ? o ? 32 : 40 : i);
  },
  x = function x(e, t) {
    var n = "mobile" === e;
    return t ? d(n ? g.space["4X"].value : g.space["6X"].value) : n ? y : k;
  },
  I = function I(e, t, n) {
    var i = "dark" === e ? "ondark" : "onlight";
    return n ? p.interactive.active[i].value : p.elements.primary[i].value;
  },
  T = function T(e, t, n) {
    var i = "dark" === e ? "ondark" : "onlight";
    return n ? "".concat(d(2), " solid ").concat(p.interactive.active[i].value) : t ? "".concat(d(2), " solid ").concat(p.elements.primary[i].value) : "".concat(d(1), " solid ").concat(p.elements.primary[i].value);
  },
  L = b.div.withConfig({
    displayName: "TriggerLinkWrapper",
    componentId: "VDS__sc-17v6uqm-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  > * {\n    outline: none;\n  }\n  padding-left: ", ";\n"])), function (_ref) {
    var e = _ref.$triggerType,
      t = _ref.viewport,
      n = _ref.$triggerAlignment;
    return "link" === e && "\n  max-width: ".concat("mobile" === t ? "50%" : "25%", ";\n  margin-right: 3px; // To avoid cut off\n  margin-top:  ").concat("middle" !== n ? d(32) : "0px", ";\n  span:last-child {\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: text-top;\n  }\n  ");
  }, d(16)),
  _ = b.span.withConfig({
    displayName: "TriggerIconWrapper",
    componentId: "VDS__sc-17v6uqm-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  right: 0;\n  > * {\n    outline: none;\n  }\n  transition: top 330ms cubic-bezier(0.22, 0.61, 0.36, 1);\n  height: auto;\n  margin-top: ", ";\n\n  ", ";\n  &:focus {\n    outline: none;\n  }\n  svg {\n    overflow: visible; //safari cuts off the border if overflow is not visible\n  }\n"])), function (_ref2) {
    var e = _ref2.$triggerPosition,
      t = _ref2.$triggerAlignment;
    return "middle" !== t ? e : "0px";
  }, function (_ref3) {
    var e = _ref3.$opened,
      t = _ref3.$triggerType;
    return "icon" === t && "\n  justify-content: ".concat(e ? "flex-start" : "flex-end", ";\n  transform: rotate(").concat(e ? "-180deg" : "0deg", ");\n  transition: transform 330ms cubic-bezier(0.22, 0.61, 0.36, 1), top 330ms cubic-bezier(0.22,0.61,0.36,1); \n");
  }),
  W = b.div.withConfig({
    displayName: "OuterElementWrapper",
    componentId: "VDS__sc-17v6uqm-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  outline: none;\n  position: relative;\n"]))),
  z = b.div.withConfig({
    displayName: "InnerElementWrapper",
    componentId: "VDS__sc-17v6uqm-3"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  text-align: left;\n  margin-bottom: 0;\n  padding: 0rem;\n  background: none;\n  border: 0;\n  overflow: visible;\n  padding-right: ", ";\n  ", ";\n  color: ", ";\n  cursor: ", ";\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  font-family: ", ";\n  ", ";\n  font-weight: ", ";\n  &:active,\n  &:hover,\n  &:focus {\n    outline: none;\n  }\n"])), function (_ref4) {
    var e = _ref4.$paddingRight;
    return e;
  }, function (_ref5) {
    var e = _ref5.$paddingTop,
      t = _ref5.$paddingBottom;
    return "\n  padding-top:  ".concat(e, ";\n  padding-bottom: ").concat(t, ";\n  transition: padding-bottom 330ms linear;\n  ");
  }, function (_ref6) {
    var e = _ref6.surface;
    return "dark" === e ? p.elements.primary.ondark.value : p.elements.primary.onlight.value;
  }, function (_ref7) {
    var e = _ref7.$alwaysOpen;
    return e ? "default" : "pointer";
  }, a.VerizonNHGeDS, function (_ref8) {
    var e = _ref8.$isMobile;
    return $(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    min-height: ", ";\n    line-height: ", ";\n  "])), e ? u.fontsize.title[16].value : u.fontsize.title[20].value, e ? u.lineheight.title[20].value : u.lineheight.title[24].value, e ? u.lineheight.title[20].value : u.lineheight.title[24].value);
  }, function (_ref9) {
    var e = _ref9.$bold;
    return e ? u.fontweight.bold.value : u.fontweight.regular.value;
  }),
  C = b.button.withConfig({
    displayName: "StyledAccordionButton",
    componentId: "VDS__sc-17v6uqm-4"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: ", ";\n  justify-content: end;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: none;\n  -webkit-tap-highlight-color: transparent;\n  padding: 0;\n  padding-top: ", ";\n  transition: padding-top 330ms linear;\n  box-sizing: border-box;\n  outline: none;\n  overflow: visible;\n  pointer-events: auto;\n  color: ", ";\n  cursor: ", ";\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  font-family: ", ";\n  ", ";\n  font-weight: ", ";\n  &:active,\n  &:hover,\n  &:focus {\n    outline: none;\n  }\n  &:active,\n  &:hover,\n  &:focus {\n    outline: none;\n  }\n\n  ", ";\n  &:focus:not(:hover):not(:focus-visible) {\n    .toggleIconWrapper > div {\n      border: none; // Only display focus state on keyboard focus, not when accordion is clicked\n    }\n  }\n"])), function (_ref0) {
    var e = _ref0.$triggerAlignment;
    return "middle" === e ? "center" : "top";
  }, function (_ref1) {
    var e = _ref1.$opened,
      t = _ref1.$triggerAlignment;
    return "middle" === t && e ? "8px" : "0px";
  }, function (_ref10) {
    var e = _ref10.surface;
    return "dark" === e ? p.elements.primary.ondark.value : p.elements.primary.onlight.value;
  }, function (_ref11) {
    var e = _ref11.$alwaysOpen;
    return e ? "default" : "pointer";
  }, a.VerizonNHGeDS, function (_ref12) {
    var e = _ref12.$isMobile;
    return $(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    min-height: ", ";\n    line-height: ", ";\n  "])), e ? u.fontsize.title[16].value : u.fontsize.title[20].value, e ? u.lineheight.title[20].value : u.lineheight.title[24].value, e ? u.lineheight.title[20].value : u.lineheight.title[24].value);
  }, function (_ref13) {
    var e = _ref13.$bold;
    return e ? u.fontweight.bold.value : u.fontweight.regular.value;
  }, function (_ref14) {
    var e = _ref14.surface,
      t = _ref14.$triggerType;
    return "\n    &::-moz-focus-inner, \n    ::-moz-focus-inner {\n      border: 0;\n    }\n    ".concat("icon" === t ? "\n    &:hover {\n      .toggleIconWrapper > div {\n        border-color: transparent !important;\n      }\n      .toggleIconWrapper a {\n        outline: none;\n        box-shadow: 0 0 0 0.0625rem ".concat(l(p.palette.gray44.value, "dark" === e ? .26 : .06), ";\n        background-color: ").concat(l(p.palette.gray44.value, "dark" === e ? .26 : .06), ";\n      }\n    }\n    &:active {\n      .toggleIconWrapper > div {\n        border-color: transparent !important;\n      }\n      .toggleIconWrapper a {\n        svg {\n          path, polygon {\n            fill: ").concat(p.interactive.active["on".concat(e)].value, ";\n          }\n        }\n      }\n    }\n    ") : "\n    &:hover {\n      .toggleIconWrapper > div {\n        border-color: transparent !important;\n      }\n    }\n    &:active {\n      .toggleIconWrapper > div {\n        border-color: transparent !important;\n      }\n    }\n    ", "\n    &:focus {\n      outline: none;\n      &:not(:hover) {\n        ").concat("link" === t ? "\n        a {\n            &:after {\n              content: \"\";\n              position: absolute;\n              top: ".concat(d(-3), ";\n              bottom: ").concat(d(-4), ";\n              right: ").concat(d(-3), ";\n              left: ").concat(d(-3), ";\n              box-sizing: border-box;\n              border: ").concat("dark" === e ? "".concat(d(s.focusring.borderwidth.value), " ").concat(s.focusring.borderstyle.value, " ").concat(s.color.focusring.ondark.value) : "".concat(d(s.focusring.borderwidth.value), " ").concat(s.focusring.borderstyle.value, " ").concat(s.color.focusring.onlight.value), ";\n              border-radius: ").concat(d(2), ";\n          }\n        }\n        ") : "\n      a:after{\n        content: '';\n        box-sizing: border-box;\n        border: 0.0625rem dashed ".concat(s.color.focusring["on".concat(e)].value, " ;\n        border-radius: 50%;\n        position: absolute;\n        width: calc(100% - 0.125rem);\n        height: calc(100% - 0.125rem);\n      }\n      "), "\n\n        \n      &:not(:hover):not(:focus-visible) {\n        a,button {\n          &:after {\n            border: none; // Only display focus state on keyboard focus, not when accordion is clicked\n          }\n        }\n    }\n  ");
  }),
  S = b.span.withConfig({
    displayName: "ScreenReaderText",
    componentId: "VDS__sc-17v6uqm-5"
  })(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n"]))),
  A = b(function (t) {
    var n = t.primitive,
      i = e(t, ["primitive"]);
    return f(n, i);
  }).withConfig({
    displayName: "WrapperDiv",
    componentId: "VDS__sc-17v6uqm-6"
  })(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: inherit;\n  padding-top: 0;\n  position: relative;\n  width: 100%;\n  ", ";\n  ", ";\n"])), function (_ref15) {
    var e = _ref15.$triggerType,
      t = _ref15.$textLinkColor,
      n = _ref15.$textLinkBorder;
    return "link" === e && $(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n      a {\n        color: ", ";\n        border-bottom: ", ";\n        vertical-align: text-top;\n      }\n    "])), t, n);
  }, function (_ref16) {
    var e = _ref16.$triggerType,
      t = _ref16.triggerHoverPosition;
    return "link" !== e && "\n      &:hover .toggleIconWrapper {\n          cursor: pointer;\n          top: ".concat(t, ";\n      }\n  ");
  });
var H = /*#__PURE__*/function (_v) {
  _inherits(H, _v);
  function H(e) {
    var _this;
    _classCallCheck(this, H);
    var t;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(H).call(this, e)), t = _assertThisInitialized(_assertThisInitialized(_this)), _this.isFirefox = "undefined" != typeof navigator && navigator.userAgent.toLowerCase().indexOf("firefox") > -1, _this.getTriggerLinkWidth = function () {
      "link" === (t.props.trigger && t.props.trigger.type ? t.props.trigger.type : t.props.triggerType) && setTimeout(function () {
        t.triggerRef && t.setState({
          triggerLinkWidth: t.triggerRef.getBoundingClientRect().width
        });
      });
    }, _this._clicked = function () {
      var e;
      var n = t.props.groupId,
        i = t.state.hovered,
        o = null === (e = document.getElementById("accordionHeader_".concat(n))) || void 0 === e ? void 0 : e.querySelector("svg");
      t.isFirefox && i && o && (o.style.border = "none"), t.setState(function (e) {
        return {
          clicked: !e.clicked
        };
      });
    }, _this._clearStates = function () {
      t.setState({
        clicked: !1,
        hovered: !1
      });
    }, _this._getTriggerLabel = function () {
      var _t$props = t.props,
        e = _t$props.openAccordionTriggerLabel,
        n = _t$props.closeAccordionTriggerLabel,
        i = _t$props.trigger,
        o = _t$props.opened;
      return o ? i && i.closeLabel || n || "Cancel" : i && i.openLabel || e || "Change";
    }, _this.state = {
      clicked: !1,
      hovered: !1,
      triggerLinkWidth: "undefined" != typeof window && window.innerWidth / 4
    };
    return _this;
  }
  _createClass(H, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      "undefined" != typeof window && window.addEventListener("resize", this.getTriggerLinkWidth), this.getTriggerLinkWidth();
      var e = this.props.groupId;
      this.accordionHeaderId = "accordionHeader_".concat(e), this.accordionAriaControlsId = "accordionDetail_".concat(e), this.accordionHeaderLabelId = "accordionHeaderLabel_".concat(e);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      var t = e.opened;
      t !== this.props.opened && this.getTriggerLinkWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      "undefined" != typeof window && window.removeEventListener("resize", this.getTriggerLinkWidth);
    }
  }, {
    key: "render",
    value: function render() {
      var e,
        a = this;
      var _this$props = this.props,
        l = _this$props.opened,
        p = _this$props.children,
        g = _this$props.onClick,
        u = _this$props.groupIndex,
        f = _this$props.groupId,
        v = _this$props.surface,
        b = _this$props.sticky,
        $ = _this$props.testMode,
        H = _this$props.viewport,
        O = _this$props.triggerType,
        D = _this$props.alwaysOpen,
        N = _this$props.onTrigger,
        B = _this$props.analyticsTrack,
        M = _this$props.track,
        R = _this$props.trackIgnore,
        j = _this$props.clickStream,
        q = _this$props.cta,
        V = _this$props.level,
        E = _this$props.position,
        P = _this$props.dataTrack,
        F = _this$props.primitive,
        X = _this$props.ariaLabel,
        U = _this$props.bold,
        G = _this$props.trigger,
        J = _this$props.ariaLive,
        K = G && G.type ? G.type : O,
        Q = G && G.alignment ? G.alignment : "top",
        Y = "mobile" === H,
        Z = "undefined" != typeof document && (null === (e = document.getElementById("accordionHeader_".concat(f))) || void 0 === e ? void 0 : e.querySelector("svg")),
        ee = X || c(p),
        te = function te(e) {
          g && g(e), G && G.onClick && G.onClick(e), N && N(e), a.getTriggerLinkWidth();
        },
        ne = "link" === K ? L : _,
        ie = this.state.triggerLinkWidth;
      return t(A, {
        "data-testid": b && $ ? "sticky_".concat(f) : void 0,
        id: this.accordionHeaderId,
        $groupIndex: u,
        surface: v,
        $triggerType: K,
        $opened: l,
        primitive: F,
        triggerHoverPosition: void 0,
        viewport: H,
        $textLinkColor: null == I ? void 0 : I(v, this.state.hovered, this.state.clicked),
        $textLinkBorder: null == T ? void 0 : T(v, this.state.hovered, this.state.clicked),
        "aria-live": J,
        children: n(W, {
          children: [n(C, {
            className: "accordionButton",
            "aria-expanded": l,
            "aria-controls": this.accordionAriaControlsId,
            id: G && G.id ? G.id : void 0,
            onClick: te,
            type: "button",
            role: "button",
            tabIndex: null == G ? void 0 : G.tabIndex,
            onFocus: function onFocus() {
              a.isFirefox && Z && (Z.style.border = "\n          ".concat(s.focusring.borderwidth.value, "\n          ").concat(s.focusring.borderstyle.value, "\n          ").concat("dark" === v ? s.color.focusring.ondark.value : s.color.focusring.onlight.value), Z.style.borderRadius = d(2));
            },
            onBlur: function onBlur() {
              a.isFirefox && Z && (Z.style.border = "none");
            },
            surface: v,
            onMouseDown: this._clicked,
            onMouseUp: this._clicked,
            onMouseEnter: function onMouseEnter() {
              return a.setState({
                hovered: !0
              });
            },
            onMouseLeave: this._clearStates,
            "aria-label": G && G.ariaLabel ? G.ariaLabel : X || "",
            "data-clickstream": j,
            "data-analyticstrack": B,
            "data-track": M,
            "data-track-ignore": R,
            "data-sitecat-datatrack": P,
            "data-sitecat-position": E,
            "data-sitecat-level": V,
            "data-sitecat-cta": q,
            $triggerType: K,
            $alwaysOpen: D,
            $opened: l,
            viewport: H,
            $bold: U,
            $paddingTop: Y ? y : k,
            $paddingBottom: null == x ? void 0 : x(H, l || D),
            $paddingRight: null == w ? void 0 : w(H, D, K, ie),
            $hasRenderTriggerIcon: !1,
            $triggerAlignment: Q,
            isMobile: Y,
            children: [t(S, {
              id: this.accordionHeaderLabelId,
              children: ee
            }), !D && n(ne, {
              className: "toggleIconWrapper",
              surface: v,
              $opened: l,
              $triggerType: K,
              $triggerAlignment: Q,
              "aria-hidden": "icon" === K && !0,
              viewport: H,
              $triggerPosition: Y ? y : k,
              ref: function ref(e) {
                a.triggerRef = e;
              },
              children: ["link" === K && t(o, {
                tabIndex: -1,
                type: "standAlone",
                size: Y ? "small" : "large",
                surface: v,
                "data-clickstream": j,
                "data-analyticstrack": B,
                "data-track": M,
                "data-track-ignore": R,
                "data-sitecat-datatrack": P,
                "data-sitecat-position": E,
                "data-sitecat-level": V,
                "data-sitecat-cta": q,
                children: this._getTriggerLabel()
              }), "icon" === K && t(i, {
                tabIndex: -1,
                kind: "ghost",
                href: "javascript:void(0)",
                role: "button",
                size: Y ? "24" : "28",
                surface: v,
                focusBorderPosition: "inside",
                "data-clickstream": j,
                "data-analyticstrack": B,
                "data-track": M,
                "data-track-ignore": R,
                "data-sitecat-datatrack": P,
                "data-sitecat-position": E,
                "data-sitecat-level": V,
                "data-sitecat-cta": q,
                iconOffset: {
                  x: 0,
                  y: Y ? -1 : -2
                },
                onClick: te,
                renderIcon: function renderIcon() {
                  return t(r, {
                    surface: v,
                    size: Y ? "16" : "medium",
                    ariaHidden: !0
                  });
                }
              })]
            })]
          }), t(z, {
            $paddingTop: Y ? y : k,
            $paddingBottom: null == x ? void 0 : x(H, l || D),
            $isMobile: Y,
            $paddingRight: null == w ? void 0 : w(H, D, K, ie),
            "data-testid": "date-test-id",
            surface: v,
            $alwaysOpen: D,
            $bold: U,
            children: h.map(p, function (e) {
              return e && e.type && "AccordionTitle" === e.type.displayName ? m(e, Object.assign(Object.assign({}, e.props), {
                surface: v,
                viewport: H,
                bold: void 0 !== e.props.bold ? e.props.bold : U
              })) : e && e.type && "AccordionSubTitle" === e.type.displayName ? m(e, Object.assign(Object.assign({}, e.props), {
                surface: v,
                viewport: H
              })) : e;
            })
          })]
        })
      });
    }
  }]);
  return H;
}(v);
H.componentType = "AccordionHeader", H.defaultProps = {
  opened: !1,
  groupIndex: 1,
  groupId: "",
  surface: "light",
  sticky: !1,
  style: {},
  testMode: !1,
  triggerType: "icon",
  alwaysOpen: !1,
  viewport: "desktop",
  primitive: "div",
  ariaLabel: void 0,
  bold: !1,
  closeAccordionTriggerLabel: "Cancel",
  openAccordionTriggerLabel: "Change"
}, H.componentType = "AccordionHeader";
export { H as default };